export const licenseEnum = {
    enum: [
        'glide',
        'amdplpa',
        'antlr-pd',
        'antlr-pd-fallback',
        'abstyles',
        'afl-1.1',
        'afl-1.2',
        'afl-2.0',
        'afl-2.1',
        'afl-3.0',
        'ampas',
        'apl-1.0',
        'adobe-glyph',
        'apafml',
        'adobe-2006',
        'agpl-1.0-only',
        'agpl-1.0-or-later',
        'afmparse',
        'against-drm',
        'aladdin',
        'adsl',
        'apache-1.0',
        'apache-1.1',
        'apache-2.0',
        'aml',
        'apsl-1.0',
        'apsl-1.1',
        'apsl-1.2',
        'apsl-2.0',
        'artistic-1.0',
        'artistic-1.0-perl',
        'artistic-1.0-cl8',
        'artistic-2.0',
        'aal',
        'bsd-1-clause',
        'bsd-2-clause',
        'bsd-2-clause-views',
        'bsd-3-clause',
        'bsd-3-clause-clear',
        'bsd-3-clause-no-nuclear-license',
        'bsd-3-clause-no-nuclear-license-2014',
        'bsd-3-clause-no-nuclear-warranty',
        'bsd-3-clause-open-mpi',
        'bsd-4-clause',
        'bsd-protection',
        'bsd-source-code',
        '0bsd',
        'bsd-3-clause-attribution',
        'bsd-2-clause-patent',
        'bsd-4-clause-uc',
        'bahyph',
        'barr',
        'beerware',
        'bittorrent-1.0',
        'bittorrent-1.1',
        'blueoak-1.0.0',
        'bsl-1.0',
        'borceux',
        'busl-1.1',
        'cern-ohl-p-2.0',
        'cern-ohl-s-2.0',
        'cern-ohl-w-2.0',
        'cern-ohl-1.1',
        'cern-ohl-1.2',
        'mit-cmu',
        'cnri-jython',
        'cnri-python',
        'cnri-python-gpl-compatible',
        'cua-opl-1.0',
        'caldera',
        'cecill-1.0',
        'cecill-1.1',
        'cecill-2.0',
        'cecill-2.1',
        'cecill-b',
        'cecill-c',
        'clartistic',
        'cpol-1.02',
        'cddl-1.0',
        'cddl-1.1',
        'cpal-1.0',
        'cpl-1.0',
        'cdla-permissive-1.0',
        'cdla-sharing-1.0',
        'catosl-1.1',
        'condor-1.1',
        'cc-by-1.0',
        'cc-by-2.0',
        'cc-by-2.5',
        'cc-by-3.0-at',
        'cc-by-3.0-us',
        'cc-by-3.0',
        'cc-by-4.0',
        'cc-by-nd-1.0',
        'cc-by-nd-2.0',
        'cc-by-nd-2.5',
        'cc-by-nd-3.0',
        'cc-by-nd-4.0',
        'cc-by-nc-1.0',
        'cc-by-nc-2.0',
        'cc-by-nc-2.5',
        'cc-by-nc-3.0',
        'cc-by-nc-4.0',
        'cc-by-nc-nd-1.0',
        'cc-by-nc-nd-2.0',
        'cc-by-nc-nd-2.5',
        'cc-by-nc-nd-3.0-igo',
        'cc-by-nc-nd-3.0',
        'cc-by-nc-nd-4.0',
        'cc-by-nc-sa-1.0',
        'cc-by-nc-sa-2.0',
        'cc-by-nc-sa-2.5',
        'cc-by-nc-sa-3.0',
        'cc-by-nc-sa-4.0',
        'cc-by-sa-1.0',
        'cc-by-sa-2.0-uk',
        'cc-by-sa-2.0',
        'cc-by-sa-2.5',
        'cc-by-sa-3.0',
        'cc-by-sa-4.0',
        'cc-by-sa-3.0-at',
        'cc-pddc',
        'cc0-1.0',
        'crossword',
        'cal-1.0',
        'cal-1.0-combined-work-exception',
        'crystalstacker',
        'cube',
        'doc',
        'dsdp',
        'dsl',
        'd-fsl-1.0',
        'wtfpl',
        'dotseqn',
        'epics',
        'eudatagrid',
        'epl-1.0',
        'epl-2.0',
        'ecl-1.0',
        'ecl-2.0',
        'efl-1.0',
        'efl-2.0',
        'mit-advertising',
        'entessa',
        'erlpl-1.1',
        'etalab-2.0',
        'eurofound',
        'eupl-1.0',
        'eupl-1.1',
        'eupl-1.2',
        'eurosym',
        'fsfap',
        'fsful',
        'fsfullr',
        'fair',
        'frameworx-1.0',
        'zenodo-freetoread-1.0',
        'freeimage',
        'ftl',
        'gl2ps',
        'agpl-3.0-only',
        'agpl-3.0-or-later',
        'gfdl-1.1-only',
        'gfdl-1.1-invariants-only',
        'gfdl-1.1-no-invariants-only',
        'gfdl-1.1-or-later',
        'gfdl-1.1-invariants-or-later',
        'gfdl-1.1-no-invariants-or-later',
        'gfdl-1.2-only',
        'gfdl-1.2-invariants-only',
        'gfdl-1.2-no-invariants-only',
        'gfdl-1.2-or-later',
        'gfdl-1.2-invariants-or-later',
        'gfdl-1.2-no-invariants-or-later',
        'gfdl-1.3-only',
        'gfdl-1.3-invariants-only',
        'gfdl-1.3-no-invariants-only',
        'gfdl-1.3-or-later',
        'gfdl-1.3-invariants-or-later',
        'gfdl-1.3-no-invariants-or-later',
        'gpl-1.0-only',
        'gpl-1.0-or-later',
        'gpl-2.0-only',
        'gpl-2.0-or-later',
        'gpl-3.0-only',
        'gpl-3.0-or-later',
        'lgpl-2.1-only',
        'lgpl-2.1-or-later',
        'lgpl-3.0-only',
        'lgpl-3.0-or-later',
        'lgpl-2.0-only',
        'lgpl-2.0-or-later',
        'geogratis',
        'giftware',
        'glulxe',
        'glwtpl',
        'htmltidy',
        'haskellreport',
        'hesa-withrights',
        'hippocratic-2.1',
        'hpnd',
        'hpnd-sell-variant',
        'ibm-pibs',
        'ipl-1.0',
        'icu',
        'ipa',
        'isc',
        'imagemagick',
        'imlib2',
        'ijg',
        'info-zip',
        'intel-acpi',
        'intel',
        'interbase-1.0',
        'user-jsim',
        'json',
        'jabber-osl',
        'jpnic',
        'jasper-2.0',
        'lppl-1.0',
        'lppl-1.1',
        'lppl-1.2',
        'lppl-1.3a',
        'lppl-1.3c',
        'latex2e',
        'bsd-3-clause-lbnl',
        'leptonica',
        'lgpllr',
        'lal-1.2',
        'lal-1.3',
        'liliq-p-1.1',
        'liliq-rplus-1.1',
        'liliq-r-1.1',
        'notspecified',
        'linux-openib',
        'localauth-withrights',
        'lucent-plan9',
        'lpl-1.0',
        'lpl-1.02',
        'mitnfa',
        'mit',
        'mit-0',
        'mit-open-group',
        'mitre',
        'makeindex',
        'mtll',
        'met-office-cp',
        'ms-pl',
        'ms-rl',
        'motosoto',
        'mpl-1.0',
        'mpl-1.1',
        'mpl-2.0',
        'mpl-2.0-no-copyleft-exception',
        'mulanpsl-1.0',
        'mulanpsl-2.0',
        'multics',
        'mup',
        'nasa-1.3',
        'nist-pd',
        'nist-pd-fallback',
        'nrl',
        'ntp',
        'ntp-0',
        'naumen',
        'nbpl-1.0',
        'net-snmp',
        'netcdf',
        'ngpl',
        'nosl',
        'npl-1.0',
        'npl-1.1',
        'newsletr',
        'geo-no-fee-unrestricted',
        'nlpl',
        'nokia',
        'ncgl-uk-2.0',
        'nposl-3.0',
        'nlod-1.0',
        'noweb',
        'oclc-2.0',
        'odbl-1.0',
        'pddl-1.0',
        'ogc-1.0',
        'oset-pl-2.1',
        'occt-pl',
        'odc-by-1.0',
        'ogl-canada-2.0',
        'ogl-uk-1.0',
        'ogl-uk-2.0',
        'ogl-uk-3.0',
        'ogtsl',
        'oldap-2.2.2',
        'oldap-1.1',
        'oldap-1.2',
        'oldap-1.3',
        'oldap-1.4',
        'oldap-2.0',
        'oldap-2.0.1',
        'oldap-2.1',
        'oldap-2.2',
        'oldap-2.2.1',
        'oldap-2.3',
        'oldap-2.4',
        'oldap-2.5',
        'oldap-2.6',
        'oldap-2.7',
        'oldap-2.8',
        'oml',
        'opl-1.0',
        'osl-1.0',
        'osl-1.1',
        'osl-2.0',
        'osl-2.1',
        'osl-3.0',
        'o-uda-1.0',
        'openssl',
        'other-at',
        'other-nc',
        'other-closed',
        'other-open',
        'other-pd',
        'php-3.0',
        'php-3.01',
        'libpng-2.0',
        'plexus',
        'polyform-noncommercial-1.0.0',
        'polyform-small-business-1.0.0',
        'postgresql',
        'python-2.0',
        'psf-2.0',
        'qpl-1.0',
        'qhull',
        'qtpl',
        'rsa-md',
        'rdisc',
        'rpsl-1.0',
        'rpl-1.1',
        'rpl-1.5',
        'rhecos-1.1',
        'rscpl',
        'ruby',
        'scea',
        'sgi-b-1.0',
        'sgi-b-1.1',
        'sgi-b-2.0',
        'ofl-1.0',
        'ofl-1.0-rfn',
        'ofl-1.0-no-rfn',
        'ofl-1.1',
        'ofl-1.1-rfn',
        'ofl-1.1-no-rfn',
        'snia',
        'blessing',
        'ssh-openssh',
        'ssh-short',
        'sax-pd',
        'saxpath',
        'swl',
        'smppl',
        'sendmail',
        'sendmail-8.23',
        'sspl-1.0',
        'simpl-2.0',
        'sleepycat',
        'shl-0.5',
        'shl-0.51',
        'spencer-86',
        'spencer-94',
        'spencer-99',
        'smlnj',
        'dli-model-use',
        'sugarcrm-1.1.3',
        'sissl',
        'sissl-1.2',
        'spl-1.0',
        'watcom-1.0',
        'tapr-ohl-1.0',
        'tcl',
        'tcp-wrappers',
        'tmate',
        'torque-1.1',
        'tu-berlin-1.0',
        'tu-berlin-2.0',
        'miros',
        'parity-6.0.0',
        'parity-7.0.0',
        'unlicense',
        'tosl',
        'ukclickusepsi',
        'ukcrown',
        'ukcrown-withrights',
        'ukpsi',
        'unicode-dfs-2015',
        'unicode-dfs-2016',
        'unicode-tou',
        'upl-1.0',
        'ncsa',
        'ucl-1.0',
        'vostrom',
        'vim',
        'vsl-1.0',
        'w3c-20150513',
        'w3c-19980720',
        'w3c',
        'wsuipa',
        'xnet',
        'x11',
        'xfree86-1.1',
        'xpp',
        'xskat',
        'xerox',
        'ypl-1.0',
        'ypl-1.1',
        'zed',
        'zend-2.0',
        'zimbra-1.3',
        'zimbra-1.4',
        'zpl-1.1',
        'zpl-2.0',
        'zpl-2.1',
        'bzip2-1.0.5',
        'bzip2-1.0.6',
        'copyleft-next-0.3.0',
        'copyleft-next-0.3.1',
        'curl',
        'diffmark',
        'dvipdfm',
        'egenix',
        'mit-enna',
        'mit-feh',
        'gsoap-1.3b',
        'gnuplot',
        'imatix',
        'libpng',
        'libselinux-1.0',
        'libtiff',
        'mpich2',
        'psfrag',
        'psutils',
        'wxwindows',
        'xinetd',
        'zlib',
        'zlib-acknowledgement',
    ],
};
//# sourceMappingURL=licensesEnum.js.map